import React, { memo } from 'react'
import Polygon from '../Navigation/Polygon'
import { theme } from '../../styles/globalStyles'
import { Accent } from '../../styles/servicesStyles'

const accent1Vars = {
  hidden: {
    x: '-100%',
    y: '-100%',
    rotate: 0,
    opacity: 0,
    scale: 1,
  },
  visible: {
    x: '-20%',
    y: '-65%',
    rotate: 85,
    opacity: 0.8,
    scale: 1.2,
  },
}

const accent2Vars = {
  hidden: {
    x: '-100%',
    y: '-100%',
    rotate: 0,
    opacity: 0,
    scale: 0.5,
  },
  visible: {
    x: '-45%',
    y: 0,
    rotate: -235,
    opacity: 0.75,
    scale: 0.85,
  },
}

const accent3Vars = {
  hidden: {
    x: '-100%',
    y: '-100%',
    rotate: 0,
    opacity: 0,
    scale: 0.4,
  },
  visible: {
    x: '-50%',
    y: '45%',
    rotate: 180,
    opacity: 1,
    scale: 0.55,
  },
}

const ServicesAccent = () => {
  return (
    <>
      <Accent
        initial='hidden'
        animate='visible'
        variants={accent1Vars}
        transition={{
          duration: 1.25,
          ease: 'easeOut',
        }}>
        <Polygon shape='heptagon' fill={theme.green} />
      </Accent>
      <Accent
        initial='hidden'
        animate='visible'
        variants={accent2Vars}
        transition={{
          duration: 1.25,
          ease: 'easeOut',
        }}>
        <Polygon shape='heptagon' fill={theme.blue} />
      </Accent>
      <Accent
        initial='hidden'
        animate='visible'
        variants={accent3Vars}
        transition={{
          duration: 1.25,
          ease: 'easeOut',
        }}>
        <Polygon shape='heptagon' fill={theme.orange} />
      </Accent>
    </>
  )
}

export default memo(ServicesAccent)
